<script setup>
import { ref, inject, nextTick, watch } from 'vue';
import MyAiChatEditor from 'dashboard/components/widgets/ClientCareWriter/MyAiChatEditor.vue';
import MyAiLoader from 'dashboard/components/widgets/conversation/my_ai_chat/MyAiLoader.vue';

const props = defineProps({
  showMyAiChatEditor: {
    type: Boolean,
    default: false,
  },
  isGeneratingContent: {
    type: Boolean,
    default: false,
  },
  generatedContent: {
    type: String,
    default: '',
  },
  placeholder: {
    type: String,
    default: undefined,
  },
});

const emit = defineEmits([
  'focus',
  'blur',
  'clearSelection',
  'contentReady',
  'send',
]);

const requestEditorHeight = inject('requestEditorHeight', () => {});

const myAiChatEditorContent = ref('');

watch(
  () => [
    props.showMyAiChatEditor,
    props.isGeneratingContent,
    props.generatedContent,
  ],
  async ([showEditor, isGenerating, content]) => {
    if (isGenerating) {
      requestEditorHeight(0);
      return;
    }

    if (showEditor && content) {
      await nextTick();
      emit('contentReady');
    }
  },
  { immediate: true }
);

const onFocus = () => {
  emit('focus');
};

const onBlur = () => {
  emit('blur');
};

const clearEditorSelection = () => {
  emit('clearSelection');
};

const onSend = () => {
  emit('send', myAiChatEditorContent.value);
  myAiChatEditorContent.value = '';
};
</script>

<template>
  <div class="relative">
    <MyAiChatEditor
      v-if="showMyAiChatEditor && !isGeneratingContent"
      v-model="myAiChatEditorContent"
      class="my_ai_chat-editor"
      :generated-content="generatedContent"
      :placeholder="placeholder"
      :min-height="4"
      :enabled-menu-options="[]"
      @focus="onFocus"
      @blur="onBlur"
      @clear-selection="clearEditorSelection"
      @send="onSend"
    />
    <div
      v-else-if="isGeneratingContent"
      class="resizable-editor-body flex flex-col justify-end mb-3"
    >
      <div
        class="bg-n-iris-5 rounded min-h-[4.75rem] w-full p-4 flex items-start"
      >
        <div class="flex items-center gap-2">
          <MyAiLoader class="text-n-iris-10 size-4" />
          <span class="text-sm text-n-iris-10">
            {{ $t('CONVERSATION.REPLYBOX.MY_AI_CHAT_THINKING') }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.my_ai_chat-editor {
  .ProseMirror-menubar {
    display: none;
  }
}
</style>
